import { createRoot } from "react-dom/client";
// Self-hosted variable fonts. Bundled into our own /assets/ chunk by Vite
// (long-cache + same-origin), so the page no longer blocks on a Google Fonts
// stylesheet round-trip. Variable = single woff2 each carries every weight.
import "@fontsource-variable/inter";
import "@fontsource-variable/jetbrains-mono";
// Jost e fontul de titlu al noului design: geometric, variabil, cel mai
// apropiat liber de Century Gothic pe care se sprijinea prototipul. Fără el,
// titlurile ar cădea pe system-ui la orice vizitator care nu are fontul local.
import "@fontsource-variable/jost";
// Side-effect imports — both no-ops when their env vars are unset.
import "./sentry";
import "./analytics";
import App from "./App.tsx";
import "./index.css";
// După index.css, ca regulile de reset din Tailwind să nu învingă tipografia
// noului design.
import "./styles/site.css";

// Reloads always start at the top. Combined with the scrollToHash helper
// that strips hashes after smooth-scroll, this means a user who scrolled
// to ROI and hit F5 lands back at the hero — instead of mid-page where
// the browser's auto-restore (or a leftover #hash) would put them.
if (typeof window !== "undefined" && "scrollRestoration" in window.history) {
  window.history.scrollRestoration = "manual";
}

createRoot(document.getElementById("root")!).render(<App />);
